var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout-item text-center"},[_c('h5',{staticClass:"md-layout-item"},[_vm._v("The provision will start soon")]),_c('br'),_c('div',[_c('md-progress-bar',{staticClass:"bar",attrs:{"md-mode":"buffer","md-value":0,"md-buffer":0}})],1),_c('br'),_c('h6',{staticClass:"md-layout-item"},[_vm._v("Please wait...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }